import React from "react";
import { Switch, Route } from "react-router-dom";

import Dashboard from "../../layouts/dashboard/Dashboard";
import Login from "../../components/iam/login";
import SsoLogin from "../../components/iam/ssologin";
import ProtectedRoute from "./ProtectedRoute";

const AppRoutes: React.FC = () => (
  <Switch>
    {/* Public routes */}
    <Route exact path="/login" component={Login} />
    <Route exact path="/sso" component={SsoLogin} />

    {/* Protected routes */}
    <ProtectedRoute path="/" component={Dashboard} />
  </Switch>
);

export default AppRoutes;
